<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20" fill="white"/>
    <rect x="14" y="17" width="22" height="17" rx="2" stroke="#80B7FF" stroke-width="2"/>
    <rect x="13" y="24" width="13" height="11" rx="3" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.callIcon }
  },
  name: "IconCallRollUp"
}
</script>